import styled from '@emotion/styled'

export const Conditions = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`
